<template>
    <div class="company">
        <Notifications/>

        <CredentialsDialog v-if="selected_credentials" :id_account="selected_credentials.id_account" :loginname="selected_credentials.loginname" :password="selected_credentials.password" :status="selected_credentials.active" :site="selected_credentials.id_site" :company="selected_credentials.id_customer"/>
        <CredentialsDialog v-else-if="company" :company="company.id_customer" :status="1"/>

        <div class="container-fluid">
            <Navbar/>

            <div class="row content">
                <div class="col-md-12 ml-md-auto">
                    <div class="container-inner">
                        <template v-if="company">
                            <div class="container-header">
                                <div class="row">
                                    <div class="col col-auto">
                                        <h2>
                                            Company: {{ company.company_name }}
                                            <sup class="subtitle">
                                              id_customer: {{ company.id_customer }}
                                            </sup>
                                        </h2>
                                        <h4 class="subtitle" v-if="accounts.length > 0">
                                            <template v-if="filteredAccounts.length !== accounts.length">Showing {{ filteredAccounts.length }} of {{ accounts.length }} credentials</template>
                                            <template v-else>Total credentials: {{ accounts.length }}</template>
                                        </h4>
                                    </div>
                                    <div class="col credentials-col">
                                        <button @click="selected_credentials = null" type="button" class="btn btn-success" data-toggle="modal" data-target="#credentials-dialog">Add credentials</button>
                                    </div>
                                </div>
                            </div>
                            <div class="container-content">

                                <div class="row filter-row">
                                    <div class="col-md-6">
                                        <input type="text" v-model="filterText" class="form-control" placeholder="Filter by site name, login name or password">
                                    </div>
                                    <div class="col-md-3">
                                        <select v-model="filterStatus" class="form-control">
                                            <option value="-1">All statuses</option>
                                            <option value="0">{{ 0|formatStatus }}</option>
                                            <option value="1">{{ 1|formatStatus }}</option>
                                            <option value="2">{{ 2|formatStatus }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 export-col">
                                        <button @click="exportCsv" type="button" class="btn btn-outline-secondary" :disabled="!filteredAccounts.length">Export CSV</button>
                                    </div>
                                </div>

                                <table class="table table-striped table-bordered table-hover table-md-responsive">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th @click="setSort('sitename')" class="sortable" :class="sortClass('sitename')">Site</th>
                                            <th @click="setSort('id_account')" class="sortable" :class="sortClass('id_account')">id_account</th>
                                            <th @click="setSort('loginname')" class="sortable" :class="sortClass('loginname')">Login name</th>
                                            <th @click="setSort('password')" class="sortable" :class="sortClass('password')">Password</th>
                                            <th @click="setSort('start_date')" class="sortable" :class="sortClass('start_date')">Created</th>
                                            <th @click="setSort('end_date')" class="sortable" :class="sortClass('end_date')">End date</th>
                                            <th @click="setSort('active')" class="sortable" :class="sortClass('active')">Status</th>
                                            <th @click="setSort('login_success')" class="sortable" :class="sortClass('login_success')">Success</th>
                                            <th @click="setSort('login_fail')" class="sortable" :class="sortClass('login_fail')">Fail</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="a in filteredAccounts" v-bind:key="a.id_account">
                                            <td>
                                                <router-link class="link" :to="{ name: 'site', params: { id_site: a.id_site }}">
                                                {{ a.sitename }}

                                                <sup>{{ a.id_site }}</sup>
                                            </router-link>
                                            </td>
                                            <td>
                                                <span class="link" data-toggle="modal" data-target="#credentials-dialog" @click="selected_credentials = a">{{ a.id_account }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.loginname }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.password }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.start_date|formatDate }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.end_date|formatDate }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.active|formatStatus }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.login_success }}</span>
                                            </td>
                                            <td>
                                                <span>{{ a.login_fail }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="accounts.length && !filteredAccounts.length" class="no-results">No credentials match the current filters.</div>
                            </div>
                        </template>
                        <template v-else-if="error">
                            An error occurred while loading company login accounts. Is the id in the URL correct?
                        </template>
                        <template v-else>
                            Loading...
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notifications from '@/components/Notifications'
import Navbar from '@/components/Navbar'
import CredentialsDialog from '@/components/CredentialsDialog'
import moment from 'moment'

import { NAME_ACRONYM } from '@/constants'

export default {
    name: 'Company',
    data() {
        return {
            selected_credentials: null,
            id_customer: null,
            filterText: '',
            filterStatus: '-1',
            sortKey: 'sitename',
            sortAsc: true,
        }
    },
    components: {
        Notifications, Navbar, CredentialsDialog
    },
    methods: {
        setSort(key) {
            if (this.sortKey === key) {
                this.sortAsc = !this.sortAsc
            } else {
                this.sortKey = key
                this.sortAsc = true
            }
        },
        sortClass(key) {
            if (this.sortKey !== key) {
                return {}
            }
            return { active: true, asc: this.sortAsc, desc: !this.sortAsc }
        },
        csvField(value) {
            const str = (value === null || value === undefined) ? '' : String(value)
            if (/[",\n]/.test(str)) {
                return '"' + str.replace(/"/g, '""') + '"'
            }
            return str
        },
        exportCsv() {
            const formatDate = this.$options.filters.formatDate
            const formatStatus = this.$options.filters.formatStatus

            const headers = ['Site', 'id_site', 'id_account', 'Login name', 'Password', 'Created', 'End date', 'Status', 'Success', 'Fail']
            const rows = this.filteredAccounts.map(a => [
                a.sitename,
                a.id_site,
                a.id_account,
                a.loginname,
                a.password,
                formatDate(a.start_date),
                formatDate(a.end_date),
                formatStatus(a.active),
                a.login_success,
                a.login_fail
            ])

            const csv = [headers, ...rows]
                .map(row => row.map(this.csvField).join(','))
                .join('\r\n')

            const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' })
            const url = URL.createObjectURL(blob)

            const companyName = (this.company && this.company.company_name) ? this.company.company_name : this.id_customer
            const filename = `credentials-${companyName}-${moment().format('YYYY-MM-DD')}.csv`.replace(/[^a-z0-9_.-]+/gi, '_')

            const link = document.createElement('a')
            link.href = url
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        }
    },
    watch: {
        '$route.params.id_customer': {
            immediate: true,
            handler(val) {
                this.id_customer = val
            }
        },
        id_customer: {
            immediate: true,
            handler(val) {
                this.$store.dispatch('fetchCompany', val)
            }
        },
        company(val) {
            document.title = val.company_name + " :: " + NAME_ACRONYM
        }
    },
    computed: {
        accounts: function() {
            return this.$store.state.accounts
        },
        company: function() {
            return this.$store.state.company
        },
        error: function() {
            return this.$store.state.error
        },
        filteredAccounts: function() {
            let accounts = this.accounts

            const text = this.filterText.trim().toLowerCase()
            if (text) {
                accounts = accounts.filter(a => {
                    return (a.sitename && a.sitename.toLowerCase().includes(text)) ||
                        (a.loginname && a.loginname.toLowerCase().includes(text)) ||
                        (a.password && a.password.toLowerCase().includes(text))
                })
            }

            if (this.filterStatus !== '-1') {
                const status = Number(this.filterStatus)
                accounts = accounts.filter(a => Number(a.active) === status)
            }

            const key = this.sortKey
            const dir = this.sortAsc ? 1 : -1

            accounts = accounts.slice().sort((a, b) => {
                let av = a[key]
                let bv = b[key]

                if (typeof av === 'string' || typeof bv === 'string') {
                    av = (av || '').toString().toLowerCase()
                    bv = (bv || '').toString().toLowerCase()
                } else {
                    av = av || 0
                    bv = bv || 0
                }

                if (av < bv) {
                    return -1 * dir
                }
                if (av > bv) {
                    return 1 * dir
                }
                return 0
            })

            return accounts
        }
    }
}
</script>

<style scoped lang="sass">
@import '@/styles/_variables.sass'

.company
    height: 100%
    position: relative

    .status-th
        min-width: 100px

    .filter-row
        margin-bottom: 15px

        .export-col
            text-align: right

    .no-results
        padding: 15px
        text-align: center
        color: $gray

    .sortable
        cursor: pointer
        user-select: none
        white-space: nowrap

        &.active
            font-weight: bold

        &::after
            display: inline-block
            width: 1em
            margin-left: 4px
            content: '\2195'
            opacity: 0.4

        &.active.asc::after
            content: '\2191'
            opacity: 1

        &.active.desc::after
            content: '\2193'
            opacity: 1

    .subtitle
        color: $gray
        font-size: $font-size
        font-weight: 400
        margin: 8px 0 0

    .link
        color: $gray
        cursor: pointer
        text-decoration: none

        &:hover
            color: $black

    .small-text
        font-size: $font-size-small

    .container
        margin-left: $sidebar-width
        height: 100%
        position: relative
        display: flex
        flex-direction: column

        .container-header
            padding: 30px
            text-align: left

            h1
                margin: 0
                font-size: $font-size-bigger

        .container-content
            padding: 10px 20px

        .container-inner
            flex-grow: 1
            overflow: auto

</style>
